import React, { Component } from "react";
import Icon from "backpack-ui/dist/components/icon";
import { SEARCH_HOST } from "../../navigation/config";
import Button from "../../Button";
import InputModal from "./InputModal";

class Mobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
    };
  }

  setActive = (event) => {
    event.preventDefault();

    this.setState({
      isActive: true,
    });
  };

  setInactive = () => {
    this.setState({
      isActive: false,
    });
  };

  render() {
    const {
      className,
      searchTerm,
      searchResults,
      onChange,
    } = this.props;

    const { isActive } = this.state;

    return (
      <React.Fragment>
        <Button
          element="a"
          className={className}
          href={SEARCH_HOST}
          onClick={this.setActive}
        >
          <Icon.Search label="Open search" />
        </Button>

        <InputModal
          isOpen={isActive}
          onRequestClose={this.setInactive}
          searchTerm={searchTerm}
          searchResults={searchResults}
          onChange={onChange}
        />
      </React.Fragment>
    );
  }
}

export default Mobile;
